import { render, staticRenderFns } from "./CnaeModal.vue?vue&type=template&id=b49ab3d6&"
import script from "./CnaeModal.vue?vue&type=script&lang=js&"
export * from "./CnaeModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports